import type { OfferTemplate, OfferTemplateContent } from '@/features/webinar/types';

/**
 * Variante A, sauf si l'A/B test envoie 0 % du trafic sur A. Sans variante B, on retombe sur A,
 * comme le back.
 */
export function selectEvergreenTestOfferContent(
  offer: OfferTemplate,
): OfferTemplateContent | null {
  const contentOf = (type: string) => offer.contents.find((content) => content.type === type);
  const prefersB = offer.abTesting && (offer.splitPercentA ?? 50) <= 0;
  return (prefersB ? contentOf('B') : undefined) ?? contentOf('A') ?? null;
}

/** Offre telle que le spectateur la reçoit : une seule variante. Le bouton reste inerte en test. */
export function toEvergreenTestOffer(offer: OfferTemplate): OfferTemplate {
  const content = selectEvergreenTestOfferContent(offer);
  return { ...offer, contents: content ? [content] : [] };
}
